'use strict';

// šie ir mini animācijām, arī meņu;
export function jconnanimInit(el) {
    if ($(el).data('connected')) {
        var prevConnected = $(el).attr('data-connected') == '1' ? 1 : 0;
        var prevTimeless = $(el).attr('data-timeless') == '1' ? 1 : 0;
        var ttlKey = $(el).attr('data-ttlkey');

        jconnanimUpdate(prevConnected, prevTimeless, ttlKey);
    }
}

export function jconnanimUpdate(connected, timeless, ttlKey) {
    var prevConnected = $('.jconnanim.v1').attr('data-connected') == '1' ? 1 : 0;
    var prevTimeless = $('.jconnanim.v1').attr('data-timeless') == '1' ? 1 : 0;

    if (!prevTimeless && timeless) {
        $('.jconnanim').empty();
    }

    $('.jconnanim').not('.v3').attr('data-connected', connected).attr('data-timeless', timeless);
    $('.jconnanim').filter('.v3').attr('data-connected', connected);
    if (!ttlKey) {
        $('.jconnanim.v3').removeClass('active').empty();
    } else {
        $('.jconnanim.v3').not('[data-key="' + ttlKey + '"]').removeClass('active').empty();
        $('.jconnanim.v3').filter('[data-key="' + ttlKey + '"]').addClass('active');
    }

    if (connected && !timeless) {
        var $el = $('.jconnanim.v1').not('.default');
        if ($el.length) {
            new clockAnimation($el);
        }
        $('.jconnanim.v2').each(function () {
            new clockAnimation(this);
        });
        $('.jconnanim.v3[data-key="' + ttlKey + '"]').each(function () {
            new clockAnimation(this);
        });
    }
}

function clockAnimation(container, inline = true) {
    const self = this;
    const tag = inline ? 'span' : 'div';

    if (!clockscene) {
        console.log('Clock animation scene not found');
        return;
    }

    this.container = $(container);

    var oldAnim = this.container.data('anim');
    if (oldAnim) {
        try {
            oldAnim.stop();
        } catch (e) {

        }
    }
    this.container.data('anim', this);

    this.element = $(`<${tag} class="clockElement"></${tag}>`);
    this.element.css({
        display: 'grid',
        position: 'absolute',
        top: '-1px',
        left: '1px',
        margin: '0 auto',
        width: '20px',
        height: '20px',
        textAlign: 'center',
        transform: 'translateX(-5px) translateY(-5px)',
    }).data({
        origwidth: 40,
        orighheight: 40
    });
    this.container.append(this.element);

    if (typeof modAnimationRun === 'undefined') {
        return;
    }
    const connectAnim = new modAnimationRun({
        autoplay: true,
        groups: clockscene.groups,
        animations: clockscene.animations,
        animationContainer: this.element.get(0)
    }, $( 'body' ).get(0) );

    connectAnim.togglePause(false);
    connectAnim.playStart();

    this.stop = function() {
        if (connectAnim) {
            connectAnim.playStop(true);
        }

        self.element.remove();
        self.element = null;
        self.container.empty();
    };
}